export default __webpack_public_path__ + "static/exam-ccda49cfc35abbd6e555ab59f08d309a.png";